<template>
  <Modal
    v-if="isOpen"
    :show="isOpen"
    :title="$t('common.session.expired')"
    :show-close-button="false"
    @close="$emit('update:isOpen', false)"
  >
    <div class="session-expired">
      <p class="session-expired__text">{{ $t('common.session.expiredMessage') }}</p>
      <button
        class="button button--primary button--medium"
        @click="handleReload"
      >
        {{ $t('common.actions.reload') }}
      </button>
    </div>
  </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useJourneyStore } from '@/stores/journeyStore'
import { useBookingStore } from '@/stores/bookingStore'
import { usePriceStore } from '@/stores/priceStore'
import Modal from '@/components/BaseComponents/Modal/Modal.vue'

export default defineComponent({
  name: 'SessionExpiredModal',
  components: {
    Modal
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:isOpen'],
  setup(props, { emit }) {
    const router = useRouter()
    const journeyStore = useJourneyStore()
    const bookingStore = useBookingStore()
    const priceStore = usePriceStore()

    const handleReload = () => {
      // Clear all stores
      journeyStore.$reset()
      bookingStore.$reset()
      priceStore.$reset()

      // Close modal and redirect
      emit('update:isOpen', false)
      window.location.href = '/'
    }

    return {
      handleReload
    }
  }
})
</script>

<style lang="scss" scoped>
.session-expired {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 1rem;

  &__text {
    @include body-large;
    padding-top: 2rem;
    text-align: center;
    color: $clr-text;
  }
}
</style>
